module.exports = __webpack_public_path__ + "img/stethoscope.7dcb8085.svg";